import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from './Icons';
export function StorySection() {
  return <section className="bg-parchment py-24 px-4" data-id="element-288">
      <div className="max-w-3xl mx-auto" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-290">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-dark mb-6 leading-relaxed text-balance" data-id="element-291">
            Si alguna vez has sentido que oras pero nadie escucha... que lees la
            Biblia pero no sientes nada... que haces todo "bien" pero por dentro
            hay un desierto... este mensaje fue escrito específicamente para ti.
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-292" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="prose prose-lg md:prose-xl prose-stone mx-auto text-dark/80" data-id="element-293">
          <p className="font-serif text-2xl text-dark mb-8" data-id="element-294">
            Recuerdo perfectamente esa tarde de martes.
          </p>

          <p data-id="element-295">
            Estaba sentado en el banco de una iglesia vacía. La Biblia abierta.
            Un salmo que no sentía. Una lista de peticiones que me pesaba como
            el plomo.
          </p>

          <p data-id="element-296">
            Había hecho todo "bien": oraba 10 minutos al día, servía en el coro,
            daba mi diezmo, evitaba los "pecados grandes".
          </p>

          <p className="font-bold text-dark" data-id="element-297">
            Pero por dentro... Me sentía como un desierto.
          </p>

          <p data-id="element-298">
            Dios era un concepto en una página. Un juez lejano. O en el mejor de
            los casos, un jefe exigente que nunca estaba satisfecho.
          </p>

          <div className="my-12 relative p-8 bg-white/50 border-l-4 border-gold rounded-r-lg shadow-sm" data-id="element-299">
            <QuoteIcon className="absolute top-4 left-4 w-8 h-8 text-gold/20" data-id="element-300" />
            <p className="relative z-10 font-serif italic text-xl text-dark m-0" data-id="element-301">
              Cerré los ojos y dije la oración más honesta de mi vida: "Dios, si
              eres real y si de verdad me amas, necesito algo más que esta
              rutina estéril. Estoy harto de saber de Ti. Quiero conocerte a
              Ti."
            </p>
          </div>

          <p data-id="element-302">
            No hubo rayos ni truenos. Pero hubo un silencio diferente. Un
            silencio que no era ausencia...
          </p>

          <p className="font-serif text-2xl text-olive font-bold my-8" data-id="element-303">
            Era Presencia.
          </p>

          <p data-id="element-304">
            Ese día descubrí algo que nadie me había enseñado en años de
            iglesia: el problema no era que Dios no hablara. Era que yo estaba
            intentando conectar con Él usando el Wi-Fi de la religión, cuando Él
            quería una línea directa de corazón a corazón.
          </p>
        </motion.div>
      </div>
    </section>;
}